import { graphql } from 'react-relay/hooks';

export const fetchProduct = graphql`
    query fetchProductQuery($id: ID!) {
        node(id: $id) {
            ...productFragment_model @alias
        }
    }
`;

export const fetchProductCompressed = graphql`
    query fetchProductCompressedQuery($id: ID!) {
        node(id: $id) {
            ...productFragment_modelCompressed @alias
        }
    }
`;
